import { apiSlice } from '../api/apiSlice';
import { setNotification } from './processSlice';

export const processApi = apiSlice.injectEndpoints({
	tagTypes: ['Process', 'AllProcess', 'identityList'],
	endpoints: (builder) => ({
		getAllProcess: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-company',
				method: 'POST',
				body: data,
			}),
			keepUnusedDataFor: 600,
			providesTags: ['AllProcess'],
		}),
		getAllProcessForControls: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-company-for-controls',
				method: 'POST',
				body: data,
			}),
			keepUnusedDataFor: 600,
			providesTags: ['AllProcess'],
		}),
		GetActiveProcessList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-company-active',
				method: 'POST',
				body: data,
			}),
			keepUnusedDataFor: 600,
			providesTags: ['AllProcess'],
		}),
		getProcessList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-accesswise-v3',
				method: 'POST',
				body: data,
			}),
			keepUnusedDataFor: 600,
			providesTags: ['Process'],
		}),
		getTaskForm: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/workflow-instance',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		submitProcess: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/submit-workflow-instance-stage',
				method: 'POST',
				body: data,
			}),
		}),
		getModuleList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-module-company',
				method: 'POST',
				body: data,
			}),
		}),
		getHorizontalList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-horizon-company',
				method: 'POST',
				body: data,
			}),
		}),
		getVerticalList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-vertical-company',
				method: 'POST',
				body: data,
			}),
		}),
		createProcess: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess',
				method: 'POST',
				body: data,
			}),
		}),
		deactivateProcess: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-code-activation',
				method: 'POST',
				body: data,
			}),
		}),
		getFormByRequestType: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process-no-pic/get-workflow-instance-stage-id',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetConversationByCaseId: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-workflow-instance-stage-conversation',
				method: 'POST',
				body: data,
			}),
			// transformResponse: (response, meta, arg) => {
			//   return {
			//     ...response,
			//     conversations: response?.conversations ? response?.conversations?.reverse() : [],
			//   };
			// },
		}),
		saveDynaFrom: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/submit-workflow-instance-stage',
				method: 'POST',
				body: data,
			}),
		}),
		GetDynaFromDetails: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-stage-meta-details',
				method: 'POST',
				body: data,
			}),
		}),
		AddTaskGroup: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntaskgroup',
				method: 'POST',
				body: data,
			}),
		}),
		getTaskGroup: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntaskgroup-company',
				method: 'POST',
				body: data,
			}),
		}),
		getTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntask-company',
				method: 'POST',
				body: data,
			}),
		}),
		addSolutionTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynsolutiontask',
				method: 'POST',
				body: data,
			}),
		}),
		getSolutionTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynsolutiontask-company-process',
				method: 'POST',
				body: data,
			}),
		}),
		GetAllSolutionTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynsolutiontask-company',
				method: 'POST',
				body: data,
			}),
		}),
		SolutionTaskList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynsolutiontask-company-process-version',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteSolutionTaskList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynsolutiontask-delete',
				method: 'POST',
				body: data,
			}),
		}),
		addSolution: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess',
				method: 'POST',
				body: data,
			}),
		}),
		AddTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntask',
				method: 'POST',
				body: data,
			}),
		}),
		ModuleDeactivateHandle: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-module-activation',
				method: 'POST',
				body: data,
			}),
		}),
		GetVerticalList: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/process/grid-vertical-all',
				method: 'GET',
			}),
		}),
		AddVertical: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-add-vertical',
				method: 'POST',
				body: data,
			}),
		}),
		VerticalDeactivateHandle: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-vertical-activation',
				method: 'POST',
				body: data,
			}),
		}),
		GetModuleList: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/process/grid-module-all',
				method: 'GET',
			}),
		}),
		AddModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-add-module',
				method: 'POST',
				body: data,
			}),
		}),
		GetHorizonList: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/process/grid-horizon-all',
				method: 'GET',
			}),
		}),
		AddHorizon: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-add-horizon',
				method: 'POST',
				body: data,
			}),
		}),
		HorizonDeactivateHandle: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-horizon-activation',
				method: 'POST',
				body: data,
			}),
		}),
		GetUserByRole: builder.mutation({
			query: (data) => ({
				url: '/authorization-service/endpoint/user/list-by-role',
				method: 'POST',
				body: data,
			}),
		}),
		EntityDesignDetail: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/design/detail',
				method: 'POST',
				body: data,
			}),
		}),
		EntityConsumerpe: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/consumerpe',
				method: 'POST',
				body: data,
			}),
		}),
		AddNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/notification/save',
				method: 'POST',
				body: data,
			}),
		}),
		GetNotificationCount: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/notification-no-pic/userid-unread-count',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;
					if (response.data.status === 'SUCCESS') {
						dispatch(
							setNotification({
								countTotal: response?.data?.countTotal,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/notification-no-pic/userid',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		MarkReadNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/notification/mark-read',
				method: 'POST',
				body: data,
			}),
		}),
		MarkNotificationAsReadWhenChatTabOpen: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process-no-pic/mark-workflow-instance-stage-notification',
				method: 'POST',
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;
					if (response.data.status === 'SUCCESS') {
						dispatch(
							setNotification({
								unreadNotificationCount: response?.data?.unreadCount,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		// GetReminderData: builder.mutation({
		//   query: (data) => ({
		//     url: "/lynorg-service/endpoint/reminder/get-by-user",
		//     method: "POST",
		//     body: data,
		//   }),
		//   async onQueryStarted(arg, { queryFulfilled, dispatch }) {
		//     try {
		//       const response = await queryFulfilled;
		//       if (response.data.status === "SUCCESS") {
		//         dispatch(
		//           setReminderNotification({
		//             unreadReminderNotificationCount: response?.data?.unreadReminderNotificationCount,
		//           })
		//         );
		//       }
		//     } catch (error) {}
		//   },
		// }),
		AddMessage: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/message/save',
				method: 'POST',
				body: data,
			}),
		}),

		GetFileUpload: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/filemngt/all-file-info',
				method: 'GET',
			}),
		}),
		AddIndividual: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/invite',
				method: 'POST',
				body: data,
			}),
		}),
		GetIndividualList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/get-invites',
				method: 'POST',
				body: data,
			}),
		}),
		GetInvitationIndividual: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/id',
				method: 'POST',
				body: data,
			}),
		}),
		SendEmailAgain: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/email',
				method: 'POST',
				body: data,
			}),
		}),
		CancelEmailInvitation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/cancel',
				method: 'POST',
				body: data,
			}),
		}),
		GetUserByID: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/get-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		SaveById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/save',
				method: 'POST',
				body: data,
			}),
		}),
		GetEmployeeListByCompanyCode: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity-no-pic/get-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetEntityList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/get-by-type',
				method: 'POST',
				body: data,
			}),
		}),

		GetCompanyInfo: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/company',
				method: 'POST',
				body: data,
			}),
		}),
		CompanyInfoBulkActivate: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/activation-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		CompanyInfoBulkDelete: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/deletion-bulk',
				method: 'POST',
				body: data,
			}),
		}),

		GetAllHigherLayer: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/get-higher-layer',
				method: 'POST',
				body: data,
			}),
		}),

		GetLowestHigherLayer: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/get-lowest',
				method: 'GET',
			}),
		}),

		CompanyInfoSave: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/save',
				method: 'POST',
				body: data,
			}),
		}),
		GetOrgstructureList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-company',
				method: 'POST',
				body: data,
			}),
		}),
		SaveOrgstructure: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/save',
				method: 'POST',
				body: data,
			}),
		}),

		GetProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/company',
				method: 'POST',
				body: data,
			}),
		}),
		SaveProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/save',
				method: 'POST',
				body: data,
			}),
		}),
		ActivationProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/activation',
				method: 'POST',
				body: data,
			}),
		}),
		BulkActivationProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/activation-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/delete',
				method: 'POST',
				body: data,
			}),
		}),
		BulkDeleteProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition/deletion-bulk',
				method: 'POST',
				body: data,
			}),
		}),

		GetHRFunctionMasterList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/company',
				method: 'POST',
				body: data,
			}),
		}),
		SaveHRFunctionMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/save',
				method: 'POST',
				body: data,
			}),
		}),
		GetPositionSerialList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/function-count',
				method: 'POST',
				body: data,
			}),
		}),

		GetHeadList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/company-function-heads',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynFormProperty: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctfps',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynProperty: builder.query({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctfps',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynFormPropertyForSolutionTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctfpl',
				method: 'POST',
				body: data,
			}),
		}),
		GetGlobalProperty: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctps',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),

		GetProccseeDropDownList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/control/company-process',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynALLFormProperty: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctfs',
				method: 'POST',
				body: data,
			}),
		}),
		ActivationEntity: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/activation-company-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateEntity: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/update-company-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		LynConditionApproval: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/add-condition-master',
				method: 'POST',
				body: data,
			}),
		}),
		ChangePassword: builder.mutation({
			query: (data) => ({
				url: '/authorization-service/endpoint/user/password-update',
				method: 'POST',
				body: data,
			}),
		}),
		sendMessage: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/message/save',
				method: 'POST',
				body: data,
			}),
		}),
		ConditionMasterList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-company-condition-master',
				method: 'POST',
				body: data,
			}),
		}),
		ConditionMasterByProcess: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-company-solution-v-condition-master',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteConditionById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/delete-condition-master',
				method: 'POST',
				body: data,
			}),
		}),

		GetAccessControlList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-company',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteAccessControl: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-remove',
				method: 'POST',
				body: data,
			}),
		}),
		AddAccessControl: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople',
				method: 'POST',
				body: data,
			}),
		}),
		GetProcessAdministration: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		AddProcessAdministration: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/save',
				method: 'POST',
				body: data,
			}),
		}),
		AddProcessAdministrationBulk: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/save-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteProcessAdministration: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/remove',
				method: 'POST',
				body: data,
			}),
		}),
		BulkDeleteProcessAdministration: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/bulk-remove',
				method: 'POST',
				body: data,
			}),
		}),
		getSubModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-module',
				method: 'POST',
				body: data,
			}),
		}),
		getControl: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/module-solutions-controls-permission',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		getSolutionByModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/module-solutions-read-permission',
				method: 'POST',
				body: data,
			}),
		}),
		getSolutionReportByModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/module-solutions-reports-read-permission',
				method: 'POST',
				body: data,
			}),
		}),
		GetProcessTaskMapList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-tasks-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetRecentlyUsedSolution: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-recent-v2',
				method: 'POST',
				body: data,
			}),
		}),
		GetFrequentlyUsedSolution: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-frequent-v2',
				method: 'POST',
				body: data,
			}),
		}),
		GlobalSearch: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/search-case',
				method: 'POST',
				body: data,
			}),
		}),
		GetSolutionCatalog: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/solution-catalog-v2',
				method: 'POST',
				body: data,
			}),
		}),
		GetCompanyAll: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-cmp-all-v2',
				method: 'POST',
				body: data,
			}),
		}),
		GetAllSpacialCase: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectstructure/bulk',
				method: 'POST',
				body: data,
			}),
		}),
		GetAllIdentityCase: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/bulk',
				method: 'POST',
				body: data,
			}),
			// transformResponse: (response) => {
			// 	return response;
			// },
			invalidatesTags: ['identityList'],
		}),
		GetAllIdentityList: builder.query({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/bulk',
				method: 'POST',
				body: data,
			}),
			// providesTags: ['identityList'],
		}),
		GetSingleStructureCase: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectstructure/single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetSingleIdentity: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			invalidatesTags: ['identityList'],
		}),
		getSingleIdentity: builder.query({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetSpacialCaseHeader: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectstructure/meta-single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetIdentityHeader: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/meta-single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		getIdentityHeader: builder.query({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/meta-single',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		IdentityBulk: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/bulk-v2',
				method: 'POST',
				body: data,
				validateStatus: (response) => {
					return response.status === 200;
				},
			}),
			// transformResponse: (response) => {
			// 	return response;
			// },
		}),
		GetIdentityDataHistory: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectidentity/get-history',
				method: 'POST',
				body: data,
				validateStatus: (response) => {
					return response.status === 200;
				},
			}),
		}),
		GetSolutionName: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-code',
				method: 'POST',
				body: data,
			}),
		}),

		UpdateAccessControlAllow: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-allow',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateAccessControlRevoke: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynmaptaskpeople-revoke',
				method: 'POST',
				body: data,
			}),
		}),
		GetFormByProcessAndCompanyCode: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynform-company-process',
				method: 'POST',
				body: data,
			}),
		}),
		GetSpacialCaseUploadValidation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectstructure/check',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetIdentityUploadValidation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyndirectstructure/check',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetSpacialCaseDetails: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report/get-report',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetDelegationCaseProperties: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/delegation/get-by-user',
				method: 'GET',
				// validateStatus: (response, result) => {
				//   return response.status === 200 && result?.status === "SUCCESS";
				// },
			}),
		}),
		GetDelegationCaseList: builder.query({
			query: (id) => ({
				url: `/lynorg-service/endpoint/report-static/delegation?lynModuleCode=${id}`,
				method: 'GET',
				// validateStatus: (response, result) => {
				//   return response.status === 200 && result?.status === "SUCCESS";
				// },
			}),
		}),
		GetGlobalDelegationCaseList: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/report-static/delegation-global',
				method: 'GET',
				// validateStatus: (response, result) => {
				//   return response.status === 200 && result?.status === "SUCCESS";
				// },
			}),
		}),
		GetControlQuestionnaireById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/external/lyntask',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetCheckAllUserCheckByIdentities: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanystructcross/check-all-user-check-by-identities',
				method: 'POST',
				body: data,
				// validateStatus: (response, result) => {
				// 	return response.status === 200 && result?.status === 'SUCCESS';
				// },
			}),
		}),
		ClimeTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/claim-workflow-instance-stage',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetCommitteeVotingHistory: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-workflow-committee-details',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		CreateWorkFlowDesign: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/add',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		UpdateWorkFlowDesign: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/update',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetAllWorkFlowDesign: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/get-all',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		GetWorkFlowDesignById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/get-by-id',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		WorkFlowDesignBulkActive: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/activate-workflow-design-bulk',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		WorkFlowDesignBulkDeactivate: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/deactivate-bulk',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		WorkFlowSolutionUpgrade: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/upgrade-solution',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
		WorkFlowConditionMasterUpgrade: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-workflow-design/upgrade-condition-master',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
		}),
	}),
});

export const {
	useGetAllProcessMutation,
	useGetAllProcessForControlsMutation,
	useGetActiveProcessListMutation,
	useDeactivateProcessMutation,
	useCreateProcessMutation,
	useGetProcessListMutation,
	useGetTaskFormMutation,
	useSubmitProcessMutation,
	useGetModuleListMutation,
	useGetHorizontalListMutation,
	useGetVerticalListMutation,
	useGetFormByRequestTypeMutation,
	useGetConversationByCaseIdMutation,
	useSaveDynaFromMutation,
	useGetDynaFromDetailsMutation,
	useGetTaskGroupMutation,
	useGetTaskMutation,
	useAddSolutionTaskMutation,
	useGetSolutionTaskMutation,
	useAddSolutionMutation,
	useAddTaskMutation,
	useModuleDeactivateHandleMutation,
	useAddVerticalMutation,
	useGetVerticalListQuery,
	useGetModuleListQuery,
	useAddModuleMutation,
	useVerticalDeactivateHandleMutation,
	useGetHorizonListQuery,
	useAddHorizonMutation,
	useHorizonDeactivateHandleMutation,
	useGetUserByRoleMutation,
	useEntityDesignDetailMutation,
	useEntityConsumerpeMutation,
	useAddNotificationMutation,
	useGetNotificationMutation,
	useMarkReadNotificationMutation,
	useAddMessageMutation,
	useGetFileUploadQuery,
	useAddIndividualMutation,
	useGetIndividualListMutation,
	useGetUserByIDMutation,
	useSaveByIdMutation,
	useGetInvitationIndividualMutation,
	useSendEmailAgainMutation,
	useCancelEmailInvitationMutation,
	useGetEmployeeListByCompanyCodeMutation,

	useGetCompanyInfoMutation,
	useCompanyInfoBulkDeleteMutation,
	useCompanyInfoBulkActivateMutation,

	useLazyGetLowestHigherLayerQuery,
	useGetLowestHigherLayerQuery,
	useGetAllHigherLayerMutation,
	useCompanyInfoSaveMutation,
	useGetOrgstructureListMutation,
	useSaveOrgstructureMutation,

	useGetProcessPositionMutation,
	useSaveProcessPositionMutation,
	useDeleteProcessPositionMutation,
	useBulkDeleteProcessPositionMutation,
	useActivationProcessPositionMutation,
	useBulkActivationProcessPositionMutation,

	useGetHRFunctionMasterListMutation,
	useSaveHRFunctionMasterMutation,
	useGetPositionSerialListMutation,
	useGetHeadListMutation,
	useGetLynFormPropertyMutation,
	useGetLynPropertyQuery,
	useGetLynFormPropertyForSolutionTaskMutation,
	useGetProccseeDropDownListMutation,
	useGetLynALLFormPropertyMutation,
	useGetEntityListMutation,
	useActivationEntityMutation,
	useUpdateEntityMutation,
	useLynConditionApprovalMutation,
	useGetAllSolutionTaskMutation,
	useAddTaskGroupMutation,
	useChangePasswordMutation,
	useSendMessageMutation,
	useSolutionTaskListMutation,
	useDeleteSolutionTaskListMutation,

	useConditionMasterListMutation,
	useConditionMasterByProcessMutation,

	useDeleteConditionByIdMutation,

	useMarkWorkflowInstanceStageMessageMutation,
	useMarkNotificationAsReadWhenChatTabOpenMutation,
	useGetAccessControlListMutation,
	useAddAccessControlMutation,
	useGetProcessAdministrationMutation,
	useAddProcessAdministrationMutation,
	useAddProcessAdministrationBulkMutation,
	useDeleteProcessAdministrationMutation,
	useDeleteAccessControlMutation,
	useGetGlobalPropertyMutation,
	useGetSubModuleMutation,
	useGetControlMutation,
	useGetSolutionByModuleMutation,
	useGetSolutionReportByModuleMutation,
	useGetProcessTaskMapListMutation,
	useGetRecentlyUsedSolutionMutation,
	useGetFrequentlyUsedSolutionMutation,
	useGlobalSearchMutation,
	useGetSolutionCatalogMutation,
	useBulkDeleteProcessAdministrationMutation,
	useGetCompanyAllMutation,
	useGetNotificationCountMutation,
	useGetAllSpacialCaseMutation,
	useGetAllSpacialListQuery,
	useGetSingleStructureCaseMutation,
	useGetSpacialCaseHeaderMutation,
	useGetSolutionNameMutation,
	useUpdateAccessControlAllowMutation,
	useUpdateAccessControlRevokeMutation,
	useGetFormByProcessAndCompanyCodeMutation,
	useGetSpacialCaseUploadValidationMutation,
	useGetSpacialCaseDetailsMutation,
	useGetSingleIdentityMutation,
	useGetSingleIdentityQuery,
	useGetIdentityHeaderMutation,
	useGetIdentityHeaderQuery,
	useGetAllIdentityCaseMutation,
	useGetAllIdentityListQuery,
	useGetIdentityUploadValidationMutation,
	useIdentityBulkMutation,
	useGetIdentityDataHistoryMutation,
	useGetDelegationCasePropertiesQuery,
	useGetDelegationCaseListQuery,
	useGetGlobalDelegationCaseListQuery,

	useGetControlQuestionnaireByIdMutation,
	useClimeTaskMutation,
	useGetCheckAllUserCheckByIdentitiesMutation,

	useGetCommitteeVotingHistoryMutation,

	useCreateWorkFlowDesignMutation,
	useUpdateWorkFlowDesignMutation,
	useGetAllWorkFlowDesignMutation,
	useGetWorkFlowDesignByIdMutation,
	useWorkFlowDesignBulkActiveMutation,
	useWorkFlowDesignBulkDeactivateMutation,
	useWorkFlowSolutionUpgradeMutation,
	useWorkFlowConditionMasterUpgradeMutation,
} = processApi;
